module.exports = __webpack_public_path__ + "img/object-mark4.f0cf14f0.png";